module.exports = __webpack_public_path__ + "static/assets/8f519ed30404968835efe89f9befdd32.gif";